<template>
    <div>
        <div class="n__container">
            <v-alert
                v-for="item in notifications"
                class="n__message"
                :key="item.id"
                :type="item.type"
                :value="true"
                dismissible
                >{{ item.text }}</v-alert
            >
        </div>

        <div class="text-xs-center">
            <v-dialog v-model="soundPlayConfirmation" width="500">
                <v-card class="headline grey lighten-2" primary-title>
                    <v-card-title class="headline grey lighten-2" primary-title>
                        Подтверждение действия
                    </v-card-title>
                    <v-card-text class="modal-text">
                        Политика безопасности браузера запрещает воспроизведение
                        звуков без разрешения пользователя. Пожалуйста,
                        подтвердите согласие на использование звуковых
                        уведомлений.
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" flat @click="assignPlaySound">
                            Подтверждаю
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import warmingSound from '@/assets/sounds/notificationSound.mp3';

export default {
    name: 'dispatcherNotification',
    data: () => ({
        dialog: true,
        notificationSound: new Audio(warmingSound),
    }),
    mounted() {
        this.notificationSound.loop = true;
        const LIFETIME_NOTIFICATION = 2500;
        this.notificationTimmer = setInterval(() => {
            const notifications = this.notifications
                .map((notification) => notification)
                .reverse();

            if (notifications.length) {
                const currentTimestamp = new Date().getTime();

                notifications.forEach((notification, index) => {
                    if (
                        notification.timeStamp + LIFETIME_NOTIFICATION <=
                            currentTimestamp &&
                        index === notifications.length - 1
                    ) {
                        this.$store.dispatch(
                            'notifications/REMOVE_NOTIFICATION',
                            notification.id
                        );
                    }
                });
            }
        }, LIFETIME_NOTIFICATION);
    },
    beforeDestroy() {
        clearInterval(this.notificationTimmer);
    },
    watch: {
        callsList() {
            const hasActiveCalls = this.callsList.filter(
                (call) => call.status === 1
            );

            if (this.callsList.length && hasActiveCalls.length) {
                this.playNotificationSound();
            }
            if (!hasActiveCalls.length) {
                this.stopNotificationSound();
            }
        },
    },
    computed: {
        ...mapGetters('dispatcher', [
            'isCallNotificationSoundActive',
            'callsList',
        ]),
        soundPlayConfirmation: {
            get: function () {
                return this.$store.getters['dispatcher/soundPlayConfirmation'];
            },
            set: function () {
                return this.$store.dispatch('dispatcher/assignPlaySound');
            },
        },
        notifications() {
            return this.$store.getters['notifications/getNotifications'];
        },
    },
    methods: {
        ...mapActions('dispatcher', ['assignPlaySound']),
        playNotificationSound() {
            this.notificationSound.pause();
            this.notificationSound = new Audio(warmingSound);
            this.notificationSound.play();
        },
        stopNotificationSound() {
            this.notificationSound.pause();
        },
    },
};
</script>

<style lang="scss" scoped>
.n {
    &__container {
        position: fixed;
        right: 0;
        bottom: 0;
        width: 350px;
        z-index: 999;
    }
}

.modal-text {
    font-size: 16px;
}
</style>
